<template>
  <div v-if="!loading">
    <ClaimedUserView v-if="claimed" :pro_user="unclaimedProUser" />
    <UnclaimedUserView v-else :pro_user="unclaimedProUser" />
  </div>
  <div v-else />
</template>

<script>
import UnclaimedUserView from './Unclaimed'
import ClaimedUserView from './Claimed'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ClaimUserView',

  props: ['claim_token'],

  components: { ClaimedUserView, UnclaimedUserView, },

  data: () => ({
    loading: true,
  }),

  computed: {
    ...mapGetters('wizard', ['unclaimedProUser']),

    claimed() {
      console.log(this.unclaimedProUser.claimed)
      return this.unclaimedProUser?.claimed
    },
  },

  methods: {
    ...mapActions('wizard', ['loadUnclaimedProUser']),
  },

  async created() {
    await this.loadUnclaimedProUser(this.claim_token)
    this.loading = false
  },
}
</script>